import React from 'react'
//import I18n from "i18n-js/index.js.erb"

export default class ReservationSegmentBuilderNavigation extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div className="steps">
        <ul className="nav nav-wizard">
          <li className={this.props.step == "accommodations" ? 'active accommodations-nav' : ''}><a href="#" onClick={this.props.onChangeStep} data-step="accommodations">{I18n.t("room_details")}</a></li>
          {/* {this.props.new_folio_items && this.props.new_folio_items.length && this.props.reservation_segment.status != "held" ? <li className={this.props.step == "confirm_and_book" ? 'active' : ''}><a href="#" onClick={this.props.onChangeStep} data-step="confirm_and_book">{I18n.t("confirm")}</a></li> : null} */}
          {this.props.payment_log_amount && this.props.payment_log_amount != 0 && this.props.reservation_segment.status != "held" || this.props.new_folio_items && this.props.new_folio_items.length > 0 ? <li className={this.props.step == "confirm_and_book" ? 'active confirm-nav' : ''}><a href="#" onClick={this.props.onChangeStep} data-step="confirm_and_book">{I18n.t("confirm")}</a></li> : null}

        </ul>
        <br />
      </div>
    )
  };

};

